export default __webpack_public_path__ + "static/media/Orange.5fc995e5.jpg";